import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./FAQSection.module.css";


const FAQSection = ({ faqs, title }) => {
  const [openIdx, setOpenIdx] = useState(null);

  const handleToggle = idx => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className={styles.faqSection}>
      {title && <h2 className={styles.faqTitle}>{title}</h2>}
      <div className={styles.faqList}>
        {faqs.map((faq, idx) => (
          <div
            className={
              styles.faqItem + (openIdx === idx ? ' ' + styles.open : '')
            }
            key={idx}
          >
            <button
              className={styles.faqQuestion}
              onClick={() => handleToggle(idx)}
              aria-expanded={openIdx === idx}
              aria-controls={`faq-answer-${idx}`}
            >
              {faq.question}
            </button>
            <div
              className={styles.faqAnswer}
              id={`faq-answer-${idx}`}
              style={openIdx === idx ? {} : { display: 'block' }}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

FAQSection.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
      ]).isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
};

export default FAQSection;
